'use client';

import { DetailsCard } from '@/components/molecules/DetailsCard';
import { SeasonInfoDetailsSkeleton } from '@/components/molecules/skeletons/SeasonInfoDetailsSkeleton';
import { useTeamLeagueInfo } from '@/hooks/custom-hooks/useTeamLeagueInfo';
import { useSeasonInfoQuery } from '@/hooks/teamLeagueSeasonInfo/useSeasoninfoQuery';

interface SeasonDetailsProps {
	teamLeagueId: string;
}

export const SeasonDetails = ({ teamLeagueId }: SeasonDetailsProps) => {
	const { data: seasonInfo, isFetching } = useSeasonInfoQuery(teamLeagueId);
	const teamLeagueInfo = useTeamLeagueInfo();

	const infoSections = [
		{ key: 'teamLeagueDescription', title: 'Description' },
		{ key: 'teamLeagueAdditionalInfo', title: 'Additional Info' },
		{ key: 'refundPolicy', title: 'Refund Policy' }
	] as const;

	const showKeywords = teamLeagueInfo.isMemberOfMlp && teamLeagueInfo.keywords;

	return (
		<>
			{isFetching ? <SeasonInfoDetailsSkeleton /> : null}

			<div className="flex flex-col gap-4">
				{!isFetching &&
					infoSections.map(({ key, title }) => {
						const value = seasonInfo?.data?.[key];
						if (!value) return null;

						return (
							<DetailsCard
								key={key}
								title={title}
								isTitleOutsideBox
								titleClassName="sm:text-lg font-semibold leading-6 text-gray-900"
								content={
									<div className="mt-2 prose font-medium text-gray-700" dangerouslySetInnerHTML={{ __html: value || '<p></p>' }} />
								}
							/>
						);
					})}

				{!isFetching && showKeywords ? (
					<DetailsCard
						title="Keywords"
						isTitleOutsideBox
						titleClassName="sm:text-lg font-semibold leading-6 text-gray-900"
						content={<p className="mt-2 font-medium text-gray-700">{teamLeagueInfo.keywords}</p>}
					/>
				) : null}
			</div>
		</>
	);
};
